import { Text as TextBase, TextProps as TextPropsBase } from '@chakra-ui/react'
import * as React from 'react'

import useLocalize from '../../hooks/useLocalize'
import { vw } from '../../styles/theme'

export type TextProps = TextPropsBase & {
  children: string
}

export const Text: React.FC<TextProps> = ({ children, ...others }) => {
  return (
    <>
      <TextBase dangerouslySetInnerHTML={{ __html: children }} {...others} />
    </>
  )
}

export type LocalizedTextProps = TextProps & {
  localizeKey: string
}

export const LocalizedText: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  const localize = useLocalize()
  return (
    <Text
      css={{
        ul: {
          paddingLeft: '1em',
          listStyleType: 'none',
          textIndent: '-1em',
        },
        'ul li:before': {
          display: 'inline',
          content: '"・"',
        },
        'ul.asterisk li:before': {
          display: 'inline',
          content: '"※"',
        },
        'ul.hyphen li:before': {
          display: 'inline',
          content: '"- "',
        },
      }}
      {...others}
    >
      {localize(localizeKey)}
    </Text>
  )
}

export const TextBody: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(20), '14px']}
      lineHeight={[vw(35), '1.75']}
      fontFamily="body"
      {...others}
    />
  )
}

export const TextBodyBold1: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(30), '18px']}
      lineHeight={['1.75', '24px']}
      fontFamily="headline2"
      {...others}
    />
  )
}

export const TextBodyBold2: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(20), '14px']}
      lineHeight={[vw(35), '1.75']}
      fontFamily="headline2"
      {...others}
    />
  )
}

export const TextNav: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(50), '24px']}
      lineHeight={[vw(60), '80px']}
      fontFamily="headline2"
      {...others}
    />
  )
}

export const TextLanguage: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(35), '16px']}
      lineHeight={1.75}
      fontFamily="headlineEn"
      fontWeight="bold"
      {...others}
    />
  )
}

// [Headline1]
// A-OTF A1 Mincho Std / Bold
// 50pt/Auto
// 60pt/Auto
export const TextHeadline1: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(60), '50px']}
      lineHeight={1.75}
      fontFamily="headline1"
      fontWeight="bold"
      {...others}
    />
  )
}

// [Subtitle]
// A-OTF Midashi Go MB31 Pro /B
// 30pt/42pt
// 30pt/42pt
export const TextSubtitle: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(30), '30px']}
      lineHeight={[vw(42), '42px']}
      fontFamily="headline2"
      fontWeight="bold"
      {...others}
    />
  )
}

// [Subtitle_en]
// Helvetica Neue /Bold
// 20pt/30pt
// 30pt/30pt
export const TextSubtitleEn: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(30), '20px']}
      lineHeight={[vw(30), '30px']}
      fontFamily="headlineEn"
      {...others}
    />
  )
}

// [Body_copy]
// Roboto /Regular
// 14pt/34pt
// 20pt/40pt
export const TextBodyCopy: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(20), '14px']}
      lineHeight={[vw(40), '34px']}
      fontFamily="body"
      {...others}
    />
  )
}

// [Body_attention_bold]
// Roboto /bold
// 10pt/auto
// 20pt/auto
export const TextBodyAttentionBold: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(20), '10px']}
      lineHeight={1.75}
      fontWeight="bold"
      fontFamily="body"
      {...others}
    />
  )
}

// [Body_attention]
// Roboto /Regular
// 10pt/auto
export const TextBodyAttention: React.FC<LocalizedTextProps> = ({ localizeKey, ...others }) => {
  return (
    <LocalizedText
      localizeKey={localizeKey}
      fontSize={[vw(20), '10px']}
      lineHeight={1.75}
      fontFamily="body"
      {...others}
    />
  )
}

// 20pt/auto

// [frame_1]
// A-OTF Midashi Go MB31 Pro /B
// 20pt/25pt
// 18pt/auto

// [frame_2]
// Helvetica Neue /Regular
// 40pt/60pt
// 40pt/60pt
